{
  "last12months": "Account balances",
  "currentAllocation": "Current allocation (positive assets only)",
  "goToReports": "Go to Reports",
  "mostRecentTransactions": "Most recent transactions",
  "mostRecentQuotes": "Most recent valuations",
  "currentInformation": "Current info",
  "currentPositions": "Current holdings",
  "cannotDisplayNegative1": "The selected field combination yields negative values for the following combination of parameters: ",
  "cannotDisplayNegative2": ". This chart does not display negative values correctly. Please select a different set of parameters.",
  "rebalancing": "Rebalancing",
  "interest": "Interest",
  "principal": "Principal"
}
